import railsFetch from "../../components/railsFetch";
import { Checkin } from "./types";

export const toggleCheckin = async (checkin: Checkin) => {
  const method = checkin.arrived ? "DELETE" : "PUT";
  return railsFetch(checkin.url, { method });
};
